
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import DeleteDialog from '@/components/uicomp/ModalDialog-Delete'
import TableOptionsDialog from './ListOptionsDialog'
const components = {
  DeleteDialog,
  TableOptionsDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
  }
}

/**
 * Computed
 *
 */
const computed = mapGetters({
  list: `Customer/Group/list`,
  meta: `Customer/Group/listMeta`,
})

/**
 * Methods
 *
 */
const methods = mapActions({
  setListOption: `Customer/Group/setListOption`,
  reload: `Customer/Group/fetchList`,
  pagePrev: `Customer/Group/pagePrev`,
  pageNext: `Customer/Group/pageNext`,
  deleteItem: `Customer/Group/remove`,
})

methods.edit = function (id) {
  this.$router.push(`/customer/group/${id}`)
}

methods.showopt = function () {
  this.$refs.TableOptionsDialog.show()
}

methods.search = function (value) {
  this.setListOption({ search: value })
}

/**
 * Watch
 *
 */
const watch = {
  meta: {
    deep: true,
    handler(n, o) {
      n.version !== o.version && this.reload()
    },
  }
}

/**
 * Event OnMounted
 *
 */
const mounted = async function() {
}

/**
 * Event OnCreated
 *
 */
const created = async function() {
  if (this.meta.filter.format !== `deep`) {
    this.setListOption({ format: `deep` })
  }
}

/**
 * Event Socket
 *
 */
const sockets = {
}

export default {
  components,
  data,
  computed,
  methods,
  watch,
  mounted,
  created,
  sockets,
}
</script>

<style scoped>
</style>

<template>
  <Row>
    <TableOptions
      :nrecord="meta.nrecord"
      :npage="meta.npage"
      :curpage="meta.curpage"
      :searchValue="meta.filter.search"
      @nextpage="pageNext"
      @prevpage="pagePrev"
      @showopt="showopt"
      @search="search"
    />
    <TableOptionsDialog ref="TableOptionsDialog"
    />

    <TableList>
      <template #head>
        <th width="40" class="text-center">#</th>
        <th width="240" class="text-left">Nama Grup</th>
        <th class="text-left">Deskripsi</th>
        <th width="80" class="text-left">Harga Toko</th>
        <th width="120" class="text-right">Jumlah Pelanggan</th>
        <th width="40" class="text-right"></th>
      </template>

        <template #body>
        <tr v-for="(item, index) in list" :key="item.id">
          <td class="text-center" v-html="index + meta.curstart"></td>
          <td class="text-left">
            <span class="link underlined" @click="edit(item.id)">{{ item.name }}</span>
          </td>
          <td class="text-left">
            {{ item.description }}
          </td>
          <td class="text-left">
            <label class="label label-success" v-if="item.use_store_discount">Ya</label>
          </td>
          <td class="text-right">
            {{ item.count }} Orang
          </td>
          <td class="text-right">
            <TButtonDelete @click="$refs.DeleteDialog.confirm(item.id, item.name)" />
          </td>
        </tr>
      </template>
    </TableList>

    <DeleteDialog ref="DeleteDialog" @submit="deleteItem($event)" />
  </Row>
</template>